// extracted by mini-css-extract-plugin
export default {"HorizontalLine":"HorizontalLine-module__HorizontalLine--jc3p"};